import{gql as e}from"@apollo/client";const t=e`
  query getUserFlowStepContentPages(
    $projectId: String!
    $topLevelOnly: Boolean
    $userFlowStepTrackId: Int!
    $userFlowStepUrl: String!
    $userFlowUrl: String!
  ) {
    userFlowStep {
      getUserFlowStepByUrl: getStepByUrl(projectId: $projectId, url: $userFlowStepUrl, userFlowUrl: $userFlowUrl) {
        contentGroup {
          contentPages(status: [PUBLISHED], topLevelOnly: $topLevelOnly) {
            ...userFlowStepContentPageForStepContentPages
            contentPageChildren(status: [PUBLISHED]) {
              ...userFlowStepContentPageForStepContentPages
              contentPageChildren(status: [PUBLISHED]) {
                ...userFlowStepContentPageForStepContentPages
                contentPageChildren(status: [PUBLISHED]) {
                  ...userFlowStepContentPageForStepContentPages
                }
              }
            }
          }
          groupingContentGroup {
            description
            id
            name
            url
          }
          id
          title
          url
          title
        }
        description
        id
        isComplete
        lastTracking {
          tag {
            id
            name
            sort
          }
        }
        url
      }
    }
  }

  fragment userFlowStepContentPageForStepContentPages on ContentPageType {
    contentPageConfigurationNavigation {
      backButtonToolTip
      enableBackButton
      enableNextButton
      isEndContentGroup
      nextButtonToolTip
    }
    hasBeenViewed
    id
    isCompleted(stepTrackingId: $userFlowStepTrackId)
    seoTitle
    sort
    title
    url
  }
`;export{t as GET_USER_FLOW_STEP_CONTENT_PAGES_QUERY};
//# sourceMappingURL=useGetUserFlowStepContentPages.graphql.js.map
